import { storage } from 'APP/packages/storage';

export function resetEmojiStickers(): void {
  storage.selectedEmojiCategory.remove();
  storage.selectedStickerPack.remove();
  storage.installedStickerPacks.remove();
  storage.publicStickerPacks.remove();
}
